/**
 * Hindi project covers — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_project_pages`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const hindiProjectCoversPack: ToilePack = {
    slug: 'hindi-project-covers',
    category: 'classroom',
    name: 'Hindi project covers',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 832, h: 1216},
    readings: [
        {key: 'letters', label: 'Letters', subject: 'a cover with Devanagari letters and the title "हिंदी परियोजना"'},
        {key: 'lamp', label: 'Lamp', subject: 'a cover with a lit diya and a scroll'},
        {key: 'book', label: 'Book', subject: 'a cover with an open book and flowers'},
    ],
    styles: [
        {key: 'sketch', label: 'Sketch pens', style: 'outlined in black fineliner and filled in with bright sketch pens in flat even colour, neat hand-drawn lines with a slight wobble', palette: 'saffron, green, red and blue', framing: 'centred on a white A4 sheet seen straight on with an even clean margin all round'},
        {key: 'pencil', label: 'Colour pencils', style: 'drawn in sharp colour pencils with soft layered shading and visible pencil strokes, a gentle hand-coloured finish', palette: 'soft pencil tones of saffron, leaf green and maroon', framing: 'filling a white A4 sheet seen straight on, a narrow pencil-ruled margin line inside the edge of the page'},
        {key: 'duo', label: 'Two-colour pen', style: 'drawn in black gel pen with one accent colour of highlighter, clean ink lines, minimal and tidy', palette: 'black ink with saffron highlighter only', framing: 'on a cream notebook page seen straight on with a generous margin'},
    ],
    directions: ['kavita', 'Premchand', 'with peacock'],
    directionHint: 'try: kavita',
    seo: {
        title: 'Hindi project covers: letters, lamp, book',
        metaDescription: 'Nine hand-drawn Hindi project covers with Devanagari letters, a diya lamp and an open book, in three pen styles.',
        h1: 'Hindi project covers: letters, lamp, book',
        tagline: 'Nine covers: Devanagari letters, a lamp and a book, each in three pen styles.',
        intro: 'Front pages for a Hindi project file, drawn by hand with pens and colours. The letters cover has Devanagari letters and the title हिंदी परियोजना, meaning Hindi project. The lamp cover has a lit diya, an oil lamp, and a scroll. The book cover has an open book and flowers. Each comes in three pen styles. Type a twist, such as kavita, Premchand or with peacock, and the same three subjects can take it.',
        useCases: [
            'a Hindi project for school',
            'a Hindi language notebook',
            'a cover for a Hindi literature file',
        ],
        faq: [
            {q: 'What does the letters cover say?', a: 'It has Devanagari letters and the title हिंदी परियोजना, which means Hindi project.'},
            {q: 'Can I type a different title?', a: 'Yes. Type the title you want, in one or two short Devanagari words; it is a request for the same layout, not a promised result.'},
            {q: 'What are the three styles?', a: 'Sketch pens use bright flat colour inside black fineliner outlines. Colour pencils give soft layered shading in pastel tones. Two-colour pen is black gel ink with one highlighter colour.'},
        ],
    },
}
